import React from 'react';

import { Volume2Icon } from '@vlabs/icons';
import { selectAppConfig } from '@vlabs/shared/selectors/appSelectors';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { CheckTypeCard } from './CheckTypeCard';
import st from './shared.module.sass';

function VideoAudioTypeCard({ onClick }) {
  const { t } = useTranslation();
  const audioModuleState = useSelector(selectAppConfig)?.antispoofing;

  return (
    <CheckTypeCard
      disabled={!audioModuleState?.url}
      icon={<Volume2Icon />}
      iconClassName={st.VideoAudioIconBg}
      onClick={onClick}
      title={t('checks:check type card.audio.title')}
      subtitle={t('checks:check type card.audio.subtitle')}
    />
  );
}

export default VideoAudioTypeCard;
